// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__fOO1i","LogoContainer":"Layout_LogoContainer__7Amyg","Container":"Layout_Container__Y2Mb+"};